import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import { auth, db } from './main'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        clientPlatform: '',
        snack: '',
        firebaseAuthLoaded: false,
        user: null,
        isAuthenticated: false,
        currentSeason: null,
        selectedSeason: null,
        seasons: [],
        teams: [],
        divisions: [],
        matches: [],
        playoffRounds: [],
        playoffMatchups: [],
        playoffMatches: [],
        players: [],
        players_stats: [],
        rosters: [],
        players_positions: [],
        locations: [],
        positions: ['P', 'C', '1B', '2B', '3B', 'SS', 'LF', 'CF', 'RF']
    },

    getters: {
        isAuthenticated(state) {
            return state.user !== null && state.user !== undefined
        },

        getSeasonById: (state) => (id) => {
            let season

            state.seasons.forEach((s) => {
                if (s.id === id) {
                    season = s
                }
            })

            return season
        },

        getCurrentSeason: (state) => {
            return state.currentSeason
        },

        getSelectedSeason: (state) => {
            return state.selectedSeason
        },

        getSortedSeasons: (state) => {
            return state.seasons.slice().sort((a, b) => {
                if (a.season > b.season) {
                    return -1
                } else if (b.season > a.season) {
                    return 1
                } else {
                    return 0
                }
            })
        },

        getSortedStandings: (state, getters) => {
            // 1. Collecting teams involved in matches for current season.
            let matchTeams = []
            state.matches.forEach((match) => {
                if (match.season_id === state.selectedSeason.id) {
                    // Processing home team.
                    let isTeamAlreadyAdded = false

                    matchTeams.forEach((team) => {
                        if (team.team_id) {
                            if (team.team_id == match.home_team_id) {
                                isTeamAlreadyAdded = true
                            }
                        }
                    })

                    if (!isTeamAlreadyAdded) {
                        matchTeams.push({
                            team_id: match.home_team_id,
                            team: getters.getTeamById(match.home_team_id).team,
                            colour: getters.getTeamById(match.home_team_id).colour,
                            gp: 0,
                            wins: 0,
                            ties: 0,
                            losses: 0,
                            points: 0,
                            rs: 0,
                            ra: 0
                        })
                    }

                    // Processing away team.
                    isTeamAlreadyAdded = false

                    matchTeams.forEach((team) => {
                        if (team.team_id) {
                            if (team.team_id == match.away_team_id) {
                                isTeamAlreadyAdded = true
                            }
                        }
                    })

                    if (!isTeamAlreadyAdded) {
                        matchTeams.push({
                            team_id: match.away_team_id,
                            team: getters.getTeamById(match.away_team_id).team,
                            colour: getters.getTeamById(match.away_team_id).colour,
                            gp: 0,
                            wins: 0,
                            ties: 0,
                            losses: 0,
                            points: 0,
                            rs: 0,
                            ra: 0
                        })
                    }
                }
            })

            // 2. For each team determine GP, Wins, Ties, Losses, Points, RS, RA, DIFF
            matchTeams.forEach((team) => {
                state.matches.forEach((match) => {
                    if (match.game_played && match.season_id === state.selectedSeason.id) {
                        if (team.team_id === match.home_team_id) {
                            team.gp += 1
                            team.rs += match.home_team_score
                            team.ra += match.away_team_score

                            if (match.home_team_score > match.away_team_score) {
                                team.wins += 1
                            } else if (match.home_team_score < match.away_team_score) {
                                team.losses += 1
                            } else {
                                team.ties += 1
                            }
                        } else if (team.team_id === match.away_team_id) {
                            team.gp += 1
                            team.rs += match.away_team_score
                            team.ra += match.home_team_score

                            if (match.away_team_score > match.home_team_score) {
                                team.wins += 1
                            } else if (match.away_team_score < match.home_team_score) {
                                team.losses += 1
                            } else {
                                team.ties += 1
                            }
                        }
                    }
                })
            })

            // 3. Calculate points for each team.
            matchTeams.forEach((team) => {
                team.points = team.wins * 2 + team.ties
            })

            let standingsSorted = matchTeams.slice().sort((a, b) => {
                if (a.points > b.points) {
                    return -1
                } else if (b.points > a.points) {
                    return 1
                } else {
                    // If points match, fewer number of games determines rank.
                    if (a.gp < b.gp) {
                        return -1
                    } else if (b.gp < a.gp) {
                        return 1
                    } else {
                        // If points and games played match, head-to-head determines rank.

                        // 1. Collect head-to-head matches and calculate wins for each team.
                        let aWins = 0
                        let bWins = 0

                        state.matches.forEach((match) => {
                            // A Team @ B Team
                            if (
                                match.away_team_id === a.team_id &&
                                match.home_team_id === b.team_id &&
                                match.season_id === state.selectedSeason.id
                            ) {
                                if (match.away_team_score > match.home_team_score) {
                                    aWins += 1
                                } else if (match.home_team_score > match.away_team_score) {
                                    bWins += 1
                                }
                            }

                            // B Team @ A Team
                            if (
                                match.away_team_id === b.team_id &&
                                match.home_team_id === a.team_id &&
                                match.season_id === state.selectedSeason.id
                            ) {
                                if (match.away_team_score > match.home_team_score) {
                                    bWins += 1
                                } else if (match.home_team_score > match.away_team_score) {
                                    aWins += 1
                                }
                            }
                        })

                        // 2. Compare the wins.
                        if (aWins > bWins) {
                            return -1
                        } else if (bWins > aWins) {
                            return 1
                        } else {
                            return 0
                        }
                    }
                }
            })

            return standingsSorted
        },

        getCalendarEntries: (state, getters) => {
            let calendarEntries = []

            state.matches.forEach((match) => {
                if (match.season_id === state.selectedSeason.id) {
                    let awayTeamName = getters.getTeamById(match.away_team_id).team
                    let homeTeamName = getters.getTeamById(match.home_team_id).team
                    let matchTitle = `${awayTeamName} @ ${homeTeamName}`
                    if (match.home_team_score + match.away_team_score >= 0) {
                        matchTitle = `${awayTeamName} (${match.away_team_score}) @ ${homeTeamName} (${match.home_team_score})`
                    }
                    calendarEntries.push({
                        title: matchTitle,
                        awayTeam: awayTeamName,
                        homeTeam: homeTeamName,
                        date: match.match_moment.format('YYYY-MM-DD'),
                        time: match.match_moment.format('HH:mm'),
                        duration: match.duration
                    })
                }
            })

            return calendarEntries
        },

        getMatchTeams: (state) => {
            // Collect teams involved in matches for selected season.
            let matchTeamIds = []

            state.matches.forEach((match) => {
                if (match.season_id === state.selectedSeason.id) {
                    matchTeamIds.push(match.away_team_id)
                    matchTeamIds.push(match.home_team_id)
                }
            })

            let uniqueMatchTeamIds = [...new Set(matchTeamIds)]

            let teams = []

            uniqueMatchTeamIds.forEach((teamId) => {
                state.teams.forEach((team) => {
                    if (team.id === teamId) {
                        teams.push(team)
                    }
                })
            })

            return teams.slice().sort((a, b) => {
                if (a.team < b.team) {
                    return -1
                } else if (b.team < a.team) {
                    return 1
                } else {
                    return 0
                }
            })
        },

        getTeamsSortedByName: (state) => {
            return state.teams.slice().sort((a, b) => {
                if (a.team < b.team) {
                    return -1
                } else if (b.team < a.team) {
                    return 1
                } else {
                    return 0
                }
            })
        },

        getTeamById: (state) => (id) => {
            let team

            state.teams.forEach((t) => {
                if (t.id === id) {
                    team = t
                }
            })

            return team
        },

        getTeamByName: (state) => (name) => {
            let team

            state.teams.forEach((t) => {
                if (t.team === name) {
                    team = t
                }
            })

            return team
        },

        getDivisionById: (state) => (id) => {
            let division

            state.divisions.forEach((d) => {
                if (d.id === id) {
                    division = d
                }
            })

            return division
        },

        getDivisionsSortedByName: (state, getters) => {
            return state.divisions.slice().sort((a, b) => {
                if (getters.getSeasonById(a.season_id).season < getters.getSeasonById(b.season_id).season) {
                    return 1
                } else if (getters.getSeasonById(a.season_id).season > getters.getSeasonById(b.season_id).season) {
                    return -1
                } else {
                    if (a.division < b.division) {
                        return -1
                    } else if (b.division < a.division) {
                        return 1
                    } else {
                        return 0
                    }
                }
            })
        },

        getDivisionsBySeason: (state) => (season_id) => {
            let divisions_this_season = []

            state.divisions.forEach((d) => {
                if (d.season_id === season_id) {
                    divisions_this_season.push(d)
                }
            })

            return divisions_this_season.slice().sort((a, b) => {
                if (a.division < b.division) {
                    return -1
                } else if (b.division < a.division) {
                    return 1
                } else {
                    return 0
                }
            })
        },

        getDivisionsBySelectedSeason: (state) => {
            return state.divisions.filter((division) => {
                if (division.season_id === state.selectedSeason.id) {
                    return true
                } else {
                    return false
                }
            })
            .slice()
            .sort((a, b) => {
                if (a.division < b.division) {
                    return -1
                } else if (b.division < a.division) {
                    return 1
                } else {
                    return 0
                }
            })
        },

        getDivisionIsDuplicate: (state) => (params) => {
            let duplicate = false

            state.divisions.forEach((division) => {
                if (division.season_id === params.season_id && division.division === params.division) {
                    duplicate = true
                }
            })

            return duplicate
        },

        getRosterById: (state) => (id) => {
            let roster

            state.rosters.forEach((r) => {
                if (r.id === id) {
                    roster = r
                }
            })

            return roster
        },

        getRostersBySeason: (state, getters) => (season_id) => {
            let rosters_this_season = []

            state.rosters.forEach((r) => {
                if (r.season_id === season_id) {
                    rosters_this_season.push(r)
                }
            })

            let sorted_rosters = []

            if (rosters_this_season.length > 0) {
                sorted_rosters = rosters_this_season.slice().sort((a, b) => {
                    let teamA = getters.getTeamById(a.team_id)
                    let teamB = getters.getTeamById(b.team_id)

                    if (teamA.team < teamB.team) {
                        return -1
                    } else if (teamB.team < teamA.team) {
                        return 1
                    } else {
                        return 0
                    }
                })
            }

            return sorted_rosters
        },

        getRostersBySelectedSeason: (state, getters) => {
            let filtered_rosters = state.rosters.filter((roster) => {
                if (roster.season_id === state.selectedSeason.id) {
                    return true
                } else {
                    return false
                }
            })
            .slice()

            let sorted_rosters = []

            if (filtered_rosters.length > 0) {
                sorted_rosters = filtered_rosters.sort((a, b) => {
                    let teamA = getters.getTeamById(a.team_id)
                    let teamB = getters.getTeamById(b.team_id)

                    if (teamA.team < teamB.team) {
                        return -1
                    } else if (teamB.team < teamA.team) {
                        return 1
                    } else {
                        return 0
                    }
                })
            }

            return sorted_rosters
        },

        getRosterIsDuplicate: (state) => (params) => {
            let duplicate = false

            state.rosters.forEach((roster) => {
                if (roster.season_id === params.season_id && roster.team_id === params.team_id) {
                    duplicate = true
                }
            })

            return duplicate
        },

        getTeamRoster: (state, getters) => (roster_id) => {
            let teamRoster = []

            if (roster_id) {
                let roster = getters.getRosterById(roster_id)
                let rosterPlayers = roster.selected_player_ids

                rosterPlayers.forEach((player_id) => {
                    // Get Player's number, full name, position and manager.
                    let playerPosition = getters.getPlayerPositionByPlayerId(player_id)

                    if (playerPosition) {
                        teamRoster.push({
                            number: playerPosition.number,
                            player: getters.getPlayerFullNameById(player_id),
                            position: playerPosition.position,
                            manager: playerPosition.manager,
                            spare: playerPosition.spare
                        })
                    } else {
                        teamRoster.push({
                            number: null,
                            player: getters.getPlayerFullNameById(player_id),
                            position: null,
                            manager: null,
                            spare: null
                        })
                    }
                })
            }

            return teamRoster
        },

        getRosterByTeamId: (state, getters) => (team_id) => {
            let roster
            let rostersThisSeason = getters.getRostersBySelectedSeason

            if (team_id) {
                rostersThisSeason.forEach((r) => {
                    if (r.team_id === team_id && r.season_id === state.selectedSeason.id) {
                        roster = r
                    }
                })
            }

            return roster
        },

        getMatchById: (state) => (id) => {
            let match

            state.matches.forEach((m) => {
                if (m.id === id) {
                    match = m
                }
            })

            return match
        },

        getMatchesSortedByDate: (state) => {
            return state.matches.slice().sort((a, b) => {
                if (a.match_moment.isBefore(b.match_moment)) {
                    return -1
                } else if (b.match_moment.isBefore(a.match_moment)) {
                    return 1
                } else {
                    return 0
                }
            })
        },

        getCompletedMatches: (state) => {
            let completedMatches = state.matches.filter((match) => {
                if (match.game_played && match.season_id === state.selectedSeason.id) {
                    return true
                } else {
                    return false
                }
            })

            return completedMatches.slice().sort((a, b) => {
                if (a.match_moment.isBefore(b.match_moment)) {
                    return -1
                } else if (b.match_moment.isBefore(a.match_moment)) {
                    return 1
                } else {
                    return 0
                }
            })
        },

        getIncompleteMatches: (state) => {
            let incompleteMatches = state.matches.filter((match) => {
                if (!match.game_played && match.season_id === state.selectedSeason.id) {
                    return true
                } else {
                    return false
                }
            })

            return incompleteMatches.slice().sort((a, b) => {
                if (a.match_moment.isBefore(b.match_moment)) {
                    return -1
                } else if (b.match_moment.isBefore(a.match_moment)) {
                    return 1
                } else {
                    return 0
                }
            })
        },

        getMatchTimeConflicts: (state, getters) => (params) => {
            let validMatchTime = true
            let teamInConflict = ''

            // Verify both teams do not already have matches at this time.
            state.matches.forEach((match) => {
                if (match.season_id === params.season_id) {
                    // Check away team.
                    if (
                        params.away_team_id === match.away_team_id ||
                        params.away_team_id === match.home_team_id
                    ) {
                        if (
                            params.newMatchStartTime.isBetween(
                                moment(match.match_moment).subtract(params.duration, 'minutes'),
                                moment(match.match_moment).add(params.duration, 'minutes')
                            )
                        ) {
                            validMatchTime = false
                            teamInConflict = getters.getTeamById(params.away_team_id).team
                        }
                    }

                    // Check home team.
                    if (
                        params.home_team_id === match.away_team_id ||
                        params.home_team_id === match.home_team_id
                    ) {
                        if (
                            params.newMatchStartTime.isBetween(
                                moment(match.match_moment).subtract(params.duration, 'minutes'),
                                moment(match.match_moment).add(params.duration, 'minutes')
                            )
                        ) {
                            validMatchTime = false
                            teamInConflict = getters.getTeamById(params.home_team_id).team
                        }
                    }
                }
            })

            return { validMatchTime, teamInConflict }
        },

        getPlayoffRoundById: (state) => (id) => {
            let round

            state.playoffRounds.forEach((r) => {
                if (r.id === id) {
                    round = r
                }
            })

            return round
        },

        getSortedPlayoffRounds: (state) => {
            if (state.playoffRounds.length === 0) {
                return null
            }

            return state.playoffRounds
                .filter((round) => {
                    if (round.season_id === state.selectedSeason.id) {
                        return true
                    } else {
                        return false
                    }
                })
                .slice()
                .sort((a, b) => {
                    if (a.round > b.round) {
                        return -1
                    } else if (b.round > a.round) {
                        return 1
                    } else {
                        return 0
                    }
                })
        },

        getPlayoffMatchupById: (state) => (id) => {
            let matchup

            state.playoffMatchups.forEach((m) => {
                if (m.id === id) {
                    matchup = m
                }
            })

            return matchup
        },

        getPlayoffMatchupsInRound: (state) => (round_id) => {
            return state.playoffMatchups
                .filter((matchup) => {
                    if (
                        matchup.round_id === round_id &&
                        matchup.season_id === state.selectedSeason.id
                    ) {
                        return true
                    } else {
                        return false
                    }
                })
                .sort((a, b) => {
                    if (a.created_at < b.created_at) {
                        return -1
                    } else if (b.created_at < a.created_at) {
                        return 1
                    } else {
                        return 0
                    }
                })
        },

        getPlayoffMatchupWins: (state, getters) => (matchup) => {
            let awayTeamWins = 0
            let homeTeamWins = 0

            let round = getters.getPlayoffRoundById(matchup.round_id)
            let awayTeam = getters.getTeamById(matchup.away_team_id)
            let homeTeam = getters.getTeamById(matchup.home_team_id)

            let matchesInMatchup = getters.getPlayoffMatchesInMatchup(matchup.round_id, matchup.id)

            // Collect number of wins for both teams.
            matchesInMatchup.forEach((match) => {
                if (match.game_played) {
                    if (match.away_team_score > match.home_team_score) {
                        // Sometimes the team with home advantage is away, compare using team IDs.
                        if (match.away_team_id === awayTeam.id) {
                            awayTeamWins += 1
                        } else {
                            homeTeamWins += 1
                        }
                    } else if (match.home_team_score > match.away_team_score) {
                        if (match.home_team_id === homeTeam.id) {
                            homeTeamWins += 1
                        } else {
                            awayTeamWins += 1
                        }
                    }
                }
            })

            return {
                awayTeam,
                awayTeamWins,
                homeTeam,
                homeTeamWins,
                bestOf: round.best_of
            }
        },

        getPlayoffMatchById: (state) => (id) => {
            let match

            state.playoffMatches.forEach((m) => {
                if (m.id === id) {
                    match = m
                }
            })

            return match
        },

        getPlayoffMatchesInMatchup: (state) => (round_id, matchup_id) => {
            return state.playoffMatches
                .filter((match) => {
                    if (
                        match.round_id === round_id &&
                        match.matchup_id === matchup_id &&
                        match.season_id === state.selectedSeason.id
                    ) {
                        return true
                    } else {
                        return false
                    }
                })
                .slice()
                .sort((a, b) => {
                    if (a.match < b.match) {
                        return -1
                    } else if (b.match < a.match) {
                        return 1
                    } else {
                        return 0
                    }
                })
        },

        getPlayerById: (state) => (id) => {
            let player

            state.players.forEach((p) => {
                if (p.id === id) {
                    player = p
                }
            })

            return player
        },

        getPlayerFullNameById: (state) => (id) => {
            let full_name

            state.players.forEach((p) => {
                if (p.id === id) {
                    full_name = `${p.first_name} ${p.last_name}`
                }
            })

            return full_name
        },

        getPlayersSortedByLastName: (state) => {
            return state.players.slice().sort((a, b) => {
                if (a.last_name.toLowerCase() < b.last_name.toLowerCase()) {
                    return -1
                } else if (b.last_name.toLowerCase() < a.last_name.toLowerCase()) {
                    return 1
                } else {
                    if (a.first_name.toLowerCase() < b.first_name.toLowerCase()) {
                        return -1
                    } else if (b.first_name.toLowerCase() < a.first_name.toLowerCase()) {
                        return 1
                    } else {
                        return 0
                    }
                }
            })
        },

        getPlayersSortedByFirstName: (state) => {
            return state.players.slice().sort((a, b) => {
                if (a.first_name.toLowerCase() < b.first_name.toLowerCase()) {
                    return -1
                } else if (b.first_name.toLowerCase() < a.first_name.toLowerCase()) {
                    return 1
                } else {
                    if (a.last_name.toLowerCase() < b.last_name.toLowerCase()) {
                        return -1
                    } else if (b.last_name.toLowerCase() < a.last_name.toLowerCase()) {
                        return 1
                    } else {
                        return 0
                    }
                }
            })
        },

        getPlayerIsDuplicate: (state) => (params) => {
            let duplicate = false

            state.players.forEach((player) => {
                if (
                    player.first_name.trim().toLowerCase() === params.first_name.trim().toLowerCase() &&
                    player.last_name.trim().toLowerCase() === params.last_name.trim().toLowerCase()
                ) {
                    duplicate = true
                }
            })

            return duplicate
        },

        getPlayerStatsById: (state) => (id) => {
            let player_stats

            state.players_stats.forEach((ps) => {
                if (ps.id === id) {
                    player_stats = ps
                }
            })

            return player_stats
        },

        getPlayerByPlayerId: (state) => (player_id) => {
            return state.players_stats
                .filter((player_stats) => {
                    if (player_stats.player_id === player_id) {
                        return true
                    } else {
                        return false
                    }
                })
        },

        getPlayerStatsIsDuplicate: (state) => (params) => {
            let duplicate = false

            state.players_stats.forEach((player_stats) => {
                let is_playoff_stat = false
                if (player_stats.is_playoff_stat) {
                    is_playoff_stat = true
                }

                if (
                    player_stats.season_id === params.player_stats.season_id &&
                    player_stats.player_id === params.player_stats.player_id &&
                    is_playoff_stat === params.player_stats.is_playoff_stat
                ) {
                    duplicate = true
                }
            })

            return duplicate
        },

        getPlayerStatsValid: () => (player_stats) => {
            let valid = false

            if (player_stats.hr > 0 || (player_stats.ip + player_stats.so > 0)) {
                valid = true
            }

            return valid
        },

        getHittingPlayersSeasonStats: (state, getters) => {
            return state.players_stats
                .filter((player_stats) => {
                    if (player_stats.season_id === state.selectedSeason.id && !player_stats.is_playoff_stat && player_stats.hr >= 1) {
                        return true
                    } else {
                        return false
                    }
                })
                .slice()
                .sort((a, b) => {
                    if (a.hr > b.hr) {
                        return -1
                    } else if (b.hr > a.hr) {
                        return 1
                    } else {
                        let playerA = getters.getPlayerById(a.player_id)
                        let playerB = getters.getPlayerById(b.player_id)
                        if (playerA.last_name.toLowerCase() < playerB.last_name.toLowerCase()) {
                            return -1
                        } else if (playerA.last_name.toLowerCase() > playerB.last_name.toLowerCase()) {
                            return 1
                        } else {
                            return 0
                        }
                    }
                })
        },

        getHittingPlayersPlayoffStats: (state, getters) => {
            return state.players_stats
                .filter((player_stats) => {
                    if (player_stats.season_id === state.selectedSeason.id && player_stats.is_playoff_stat && player_stats.hr >= 1) {
                        return true
                    } else {
                        return false
                    }
                })
                .slice()
                .sort((a, b) => {
                    if (a.hr > b.hr) {
                        return -1
                    } else if (b.hr > a.hr) {
                        return 1
                    } else {
                        let playerA = getters.getPlayerById(a.player_id)
                        let playerB = getters.getPlayerById(b.player_id)
                        if (playerA.last_name.toLowerCase() < playerB.last_name.toLowerCase()) {
                            return -1
                        } else if (playerA.last_name.toLowerCase() > playerB.last_name.toLowerCase()) {
                            return 1
                        } else {
                            return 0
                        }
                    }
                })
        },

        getHittingTeamsSeasonStats: (state, getters) => {
            let team_hrs = {}

            state.players_stats.filter((player_stats) => {
                if (player_stats.season_id === state.selectedSeason.id && !player_stats.is_playoff_stat && player_stats.hr >= 1) {
                    return true
                } else {
                    return false
                }
            })
            .forEach((stat) => {
                if (stat.team_id in team_hrs) {
                    team_hrs[stat.team_id] = team_hrs[stat.team_id] + stat.hr
                } else {
                    team_hrs[stat.team_id] = stat.hr
                }
            })

            let team_hrs_array = []

            Object.keys(team_hrs).forEach(team => {
                team_hrs_array.push({ team_id: team, hr: team_hrs[team] })
            });

            return team_hrs_array.sort((a, b) => {
                if (a.hr > b.hr) {
                    return -1
                } else if (b.hr > a.hr) {
                    return 1
                } else {
                    let teamA = getters.getTeamById(a.team_id)
                    let teamB = getters.getTeamById(b.team_id)

                    if (teamA.team < teamB.team) {
                        return -1
                    } else if (teamA.team > teamB.team) {
                        return 1
                    } else {
                        return 0
                    }
                }
            })
        },

        getHittingTeamsPlayoffStats: (state, getters) => {
            let team_hrs = {}

            state.players_stats.filter((player_stats) => {
                if (player_stats.season_id === state.selectedSeason.id && player_stats.is_playoff_stat && player_stats.hr >= 1) {
                    return true
                } else {
                    return false
                }
            })
            .forEach((stat) => {
                if (stat.team_id in team_hrs) {
                    team_hrs[stat.team_id] = team_hrs[stat.team_id] + stat.hr
                } else {
                    team_hrs[stat.team_id] = stat.hr
                }
            })

            let team_hrs_array = []

            Object.keys(team_hrs).forEach(team => {
                team_hrs_array.push({ team_id: team, hr: team_hrs[team] })
            });

            return team_hrs_array.sort((a, b) => {
                if (a.hr > b.hr) {
                    return -1
                } else if (b.hr > a.hr) {
                    return 1
                } else {
                    let teamA = getters.getTeamById(a.team_id)
                    let teamB = getters.getTeamById(b.team_id)

                    if (teamA.team < teamB.team) {
                        return -1
                    } else if (teamA.team > teamB.team) {
                        return 1
                    } else {
                        return 0
                    }
                }
            })
        },

        getPitchingPlayersSeasonStats: (state, getters) => {
            return state.players_stats
                .filter((player_stats) => {
                    if (player_stats.season_id === state.selectedSeason.id && !player_stats.is_playoff_stat && (player_stats.ip + player_stats.so > 0)) {
                        return true
                    } else {
                        return false
                    }
                })
                .slice()
                .sort((a, b) => {
                    if (a.so > b.so) {
                        return -1
                    } else if (b.so > a.so) {
                        return 1
                    } else {
                        let playerA = getters.getPlayerById(a.player_id)
                        let playerB = getters.getPlayerById(b.player_id)
                        if (playerA.last_name.toLowerCase() < playerB.last_name.toLowerCase()) {
                            return -1
                        } else if (playerA.last_name.toLowerCase() > playerB.last_name.toLowerCase()) {
                            return 1
                        } else {
                            return 0
                        }
                    }
                })
        },

        getPitchingPlayersPlayoffStats: (state, getters) => {
            return state.players_stats
                .filter((player_stats) => {
                    if (player_stats.season_id === state.selectedSeason.id && player_stats.is_playoff_stat && (player_stats.ip + player_stats.so > 0)) {
                        return true
                    } else {
                        return false
                    }
                })
                .slice()
                .sort((a, b) => {
                    if (a.so > b.so) {
                        return -1
                    } else if (b.so > a.so) {
                        return 1
                    } else {
                        let playerA = getters.getPlayerById(a.player_id)
                        let playerB = getters.getPlayerById(b.player_id)
                        if (playerA.last_name.toLowerCase() < playerB.last_name.toLowerCase()) {
                            return -1
                        } else if (playerA.last_name.toLowerCase() > playerB.last_name.toLowerCase()) {
                            return 1
                        } else {
                            return 0
                        }
                    }
                })
        },

        getPitchingTeamsSeasonStats: (state, getters) => {
            let team_sos = {}
            let team_ips = {}

            state.players_stats.filter((player_stats) => {
                if (player_stats.season_id === state.selectedSeason.id && !player_stats.is_playoff_stat && (player_stats.ip + player_stats.so > 0)) {
                    return true
                } else {
                    return false
                }
            })
            .forEach((stat) => {
                if (stat.team_id in team_sos) {
                    team_sos[stat.team_id] = team_sos[stat.team_id] + stat.so
                } else {
                    team_sos[stat.team_id] = stat.so
                }

                if (stat.team_id in team_ips) {
                    team_ips[stat.team_id] = team_ips[stat.team_id] + stat.ip
                } else {
                    team_ips[stat.team_id] = stat.ip
                }
            })

            let team_sos_array = []

            Object.keys(team_sos).forEach(team => {
                team_sos_array.push({ team_id: team, so: team_sos[team], ip: team_ips[team] })
            });

            return team_sos_array.sort((a, b) => {
                if (a.so > b.so) {
                    return -1
                } else if (b.so > a.so) {
                    return 1
                } else {
                    let teamA = getters.getTeamById(a.team_id)
                    let teamB = getters.getTeamById(b.team_id)

                    if (teamA.team < teamB.team) {
                        return -1
                    } else if (teamA.team > teamB.team) {
                        return 1
                    } else {
                        return 0
                    }
                }
            })
        },

        getPitchingTeamsPlayoffStats: (state, getters) => {
            let team_sos = {}
            let team_ips = {}

            state.players_stats.filter((player_stats) => {
                if (player_stats.season_id === state.selectedSeason.id && player_stats.is_playoff_stat && (player_stats.ip + player_stats.so > 0)) {
                    return true
                } else {
                    return false
                }
            })
            .forEach((stat) => {
                if (stat.team_id in team_sos) {
                    team_sos[stat.team_id] = team_sos[stat.team_id] + stat.so
                } else {
                    team_sos[stat.team_id] = stat.so

                }
                if (stat.team_id in team_ips) {
                    team_ips[stat.team_id] = team_ips[stat.team_id] + stat.ip
                } else {
                    team_ips[stat.team_id] = stat.ip
                }
            })

            let team_sos_array = []

            Object.keys(team_sos).forEach(team => {
                team_sos_array.push({ team_id: team, so: team_sos[team], ip: team_ips[team] })
            });

            return team_sos_array.sort((a, b) => {
                if (a.so > b.so) {
                    return -1
                } else if (b.so > a.so) {
                    return 1
                } else {
                    let teamA = getters.getTeamById(a.team_id)
                    let teamB = getters.getTeamById(b.team_id)

                    if (teamA.team < teamB.team) {
                        return -1
                    } else if (teamA.team > teamB.team) {
                        return 1
                    } else {
                        return 0
                    }
                }
            })
        },

        getPlayerPositionById: (state) => (id) => {
            let player_position

            state.players_positions.forEach((pp) => {
                if (pp.id === id) {
                    player_position = pp
                }
            })

            return player_position
        },

        getPlayersPositionsBySeason: (state) => (season_id) => {
            let player_positions_this_season = []

            state.players_positions.forEach((pp) => {
                if (pp.season_id === season_id) {
                    player_positions_this_season.push(pp)
                }
            })

            return player_positions_this_season
        },

        getPlayersPositionsBySelectedSeason: (state) => {
            return state.players_positions.filter((pp) => {
                if (pp.season_id === state.selectedSeason.id) {
                    return true
                } else {
                    return false
                }
            })
        },

        getPlayerPositionIsDuplicate: (state) => (params) => {
            let duplicate = false

            state.players_positions.forEach((pp) => {
                if (pp.season_id === params.season_id && pp.player_id === params.player_id) {
                    duplicate = true
                }
            })

            return duplicate
        },

        getPlayerPositionByPlayerId: (state) => (player_id) => {
            let player_position

            state.players_positions.forEach((pp) => {
                if (pp.player_id === player_id && pp.season_id === state.selectedSeason.id) {
                    player_position = pp
                }
            })

            return player_position
        },

        getLocationById: (state) => (id) => {
            let location

            state.locations.forEach((l) => {
                if (l.id === id) {
                    location = l
                }
            })

            return location
        },

        getLocationsSorted: (state) => {
            return state.locations.slice().sort((a, b) => {
                if (a.location.toLowerCase() < b.location.toLowerCase()) {
                    return -1
                } else if (b.location.toLowerCase() < a.location.toLowerCase()) {
                    return 1
                } else {
                    return 0
                }
            })
        },

        getLocationIsDuplicate: (state) => (params) => {
            let duplicate = false

            state.locations.forEach((location) => {
                if (location.location.trim().toLowerCase() === params.location.trim().toLowerCase()) {
                    duplicate = true
                }
            })

            return duplicate
        }
    },

    mutations: {
        setFirebaseAuthLoaded(state, payload) {
            state.firebaseAuthLoaded = payload
        },
        setClientPlatform(state, payload) {
            state.clientPlatform = payload
        },
        setSnack(state, payload) {
            state.snack = payload
        },
        setSeasons(state, payload) {
            state.seasons = payload
        },
        setCurrentSeason(state, payload) {
            state.currentSeason = payload
        },
        setSelectedSeason(state, payload) {
            state.selectedSeason = payload
        },
        setTeams(state, payload) {
            state.teams = payload
        },
        setDivisions(state, payload) {
            state.divisions = payload
        },
        setMatches(state, payload) {
            state.matches = payload
        },
        setPlayoffRounds(state, payload) {
            state.playoffRounds = payload
        },
        setPlayoffMatchups(state, payload) {
            state.playoffMatchups = payload
        },
        setPlayoffMatches(state, payload) {
            state.playoffMatches = payload
        },
        setPlayers(state, payload) {
            state.players = payload
        },
        setPlayersStats(state, payload) {
            state.players_stats = payload
        },
        setRosters(state, payload) {
            state.rosters = payload
        },
        setPlayersPositions(state, payload) {
            state.players_positions = payload
        },
        setLocations(state, payload) {
            state.locations = payload
        },
        setUser(state, payload) {
            state.user = payload
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload
        }
    },

    actions: {
        userJoin({ commit }, { email, password }) {
            auth.createUserWithEmailAndPassword(email, password)
                .then(() => {
                    router.push('/admin')
                    commit('setSnack', 'Login created.')
                })
                .catch(() => {
                    router.push('/')
                    commit('setSnack', 'Error creating login.')
                })
        },

        userLogin({ commit }, { email, password }) {
            auth.signInWithEmailAndPassword(email, password)
                .then(() => {
                    router.push('/admin')
                    commit('setSnack', 'Login successful.')
                })
                .catch(() => {
                    router.push('/signin')
                    commit('setSnack', 'Error logging in.')
                })
        },

        userLogout({ commit }) {
            auth.signOut()
            .then(() => {
                router.push('/')
                commit('setSnack', 'Logout successful.')
            })
            .catch(() => {
                router.push('/')
                commit('setSnack', 'Error logging out.')
            })
        },

        loadSeasonData({commit}) {
            // Get seasons from Firebase and load into store.
            // Seasons will be updated in realtime.
            return new Promise((resolve, reject) => {
                db.collection('seasons')
                .orderBy('season', 'desc')
                .get()
                .then((seasonsCollection) => {
                        let seasons = []

                        seasonsCollection.forEach((season) => {
                            let seasonData = season.data()
                            seasonData.id = season.id
                            seasons.push(seasonData)
                        })

                        commit('setSeasons', seasons)

                        // Select current season to the first value which should be the most recent year.
                        if (seasons.length > 0) {
                            commit('setCurrentSeason', seasons[0])
                            commit('setSelectedSeason', seasons[0])
                            resolve()
                        }
                    },
                    (error) => {
                        console.log(`Error loading seasons: ${error}`)
                        this.commit('setSnack', 'Error loading seasons.')
                        reject()
                    }
                )
            })
        },

        createSeason({ commit }, { season }) {
            db.collection('seasons')
            .add({
                season,
                created_at: moment().toDate(),
                updated_at: moment().toDate()
            })
            .then(() => {
                router.push('/admin/seasons')
                commit('setSnack', 'Season created.')
            })
            .catch((err) => {
                console.log(`Error adding season to database. ${err}`)
                commit('setSnack', 'Error creating season.')
            })
        },

        deleteSeason({ commit }, { season }) {
            let seasonIsEmpty = true

            // Makes sure there are no matches assigned to this season.
            this.state.matches.forEach((match) => {
                if (match.season_id === season.id) {
                    seasonIsEmpty = false
                }
            })

            // Only delete the season if no matches are assigned.
            if (seasonIsEmpty) {
                db.collection('seasons')
                .doc(season.id)
                .delete()
                .then(() => {
                    commit('setSnack', 'Season deleted.')
                })
                .catch((err) => {
                    console.log(`Error deleting season from database. ${err}`)
                    commit('setSnack', 'Error deleting season.')
                })
            } else {
                commit('setSnack', 'Cannot delete season with assigned matches.')
            }
        },

        loadTeamData(context) {
            // Get teams from Firebase and load into store.
            // Teams will be updated in realtime.
            db.collection('teams').onSnapshot(
                (teamsCollection) => {
                    let teams = []

                    teamsCollection.forEach((team) => {
                        let teamData = team.data()
                        teamData.id = team.id
                        teams.push(teamData)
                    })

                    context.commit('setTeams', teams)
                },
                (error) => {
                    console.log(`Error loading teams: ${error}`)
                    this.commit('setSnack', 'Error loading teams.')
                }
            )
        },

        createTeam({ commit }, team) {
            // Add team to firestore.
            db.collection('teams')
            .add({
                team: team.team,
                location: team.location,
                manager_name: team.manager_name,
                manager_email: team.manager_email,
                manager_phone: team.manager_phone,
                colour: team.colour,
                created_at: moment().toDate(),
                updated_at: moment().toDate()
            })
            .then(() => {
                router.push('/admin/teams')
                commit('setSnack', 'Team created.')
            })
            .catch((err) => {
                console.log(`Error adding team to database. ${err}`)
                commit('setSnack', 'Error creating team.')
            })
        },

        deleteTeam({ commit }, team) {
            let teamIsEmpty = true

            // Makes sure there are no matches assigned to this season.
            this.state.matches.forEach((match) => {
                if (
                    match.season === this.state.selectedSeason &&
                    (match.away_team === team.team || match.home_team === team.team)
                ) {
                    teamIsEmpty = false
                }
            })

            // Only delete the team if no matches are assigned.
            if (teamIsEmpty) {
                // Delete from firestore.
                db.collection('teams')
                .doc(team.id)
                .delete()
                .then(() => {
                    commit('setSnack', 'Team deleted.')
                })
                .catch((err) => {
                    console.log(`Error deleting team from database. ${err}`)
                    commit('setSnack', 'Error deleting team.')
                })
            } else {
                commit('setSnack', 'Cannot delete team with assigned matches.')
            }
        },

        updateTeam({ commit }, team) {
            db.collection('teams')
            .doc(team.id)
            .update({
                team: team.team,
                location: team.location,
                manager_name: team.manager_name,
                manager_email: team.manager_email,
                manager_phone: team.manager_phone,
                colour: team.colour,
                updated_at: moment().toDate()
            })
            .then(() => {
                router.push('/admin/teams')
                commit('setSnack', 'Team updated.')
            })
            .catch((err) => {
                console.log(`Error updating team in database. ${err}`)
                commit('setSnack', 'Error updating team.')
            })
        },

        loadDivisionData({state, commit}) {
            db.collection('divisions')
            .where('season_id', '==', state.selectedSeason.id)
            .onSnapshot(
                (divisionsCollection) => {
                    let divisions = []

                    divisionsCollection.forEach((division) => {
                        let divisionData = division.data()
                        divisionData.id = division.id
                        divisions.push(divisionData)
                    })

                    commit('setDivisions', divisions)
                },
                (error) => {
                    console.log(`Error loading divisions: ${error}`)
                    commit('setSnack', 'Error loading divisions.')
                }
            )
        },

        createDivision({ commit, getters }, division) {
            let divisionDuplicateCheck = getters.getDivisionIsDuplicate({
                division: division.division,
                season_id: division.season_id
            })

            if (!divisionDuplicateCheck) {
                db.collection('divisions')
                .add({
                    division: division.division,
                    season_id: division.season_id,
                    selected_team_ids: division.selected_team_ids,
                    created_at: moment().toDate(),
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/divisions')
                    commit('setSnack', 'Division created.')
                })
                .catch((err) => {
                    console.log(`Error adding division to database. ${err}`)
                    commit('setSnack', 'Error creating division.')
                })
            } else {
                commit(
                    'setSnack',
                    'Division already exists for this season.'
                )
            }

        },

        deleteDivision({ commit }, { division }) {
            db.collection('divisions')
            .doc(division.id)
            .delete()
            .then(() => {
                commit('setSnack', 'Division deleted.')
            })
            .catch((err) => {
                console.log(`Error deleting division from database. ${err}`)
                commit('setSnack', 'Error deleting division.')
            })
        },

        updateDivision({ commit }, division) {
            db.collection('divisions')
            .doc(division.id)
            .update({
                division: division.division,
                season_id: division.season_id,
                selected_team_ids: division.selected_team_ids,
                updated_at: moment().toDate()
            })
            .then(() => {
                router.push('/admin/divisions')
                commit('setSnack', 'Division updated.')
            })
            .catch((err) => {
                console.log(`Error updating division in database. ${err}`)
                commit('setSnack', 'Error updating division.')
            })
        },

        loadRostersData(context) {
            db.collection('rosters').onSnapshot((rostersCollection) => {
                let rosters = []

                rostersCollection.forEach((roster) => {
                    let rosterData = roster.data()
                    rosterData.id = roster.id
                    rosters.push(rosterData)
                })

                context.commit('setRosters', rosters)
            },
            (error) => {
                console.log(`Error loading rosters: ${error}`)
                this.commit('setSnack', 'Error loading rosters.')
            })
        },

        createRoster({ commit, getters }, roster) {
            let rosterDuplicateCheck = getters.getRosterIsDuplicate({
                season_id: roster.season_id,
                team_id: roster.team_id
            })

            if (!rosterDuplicateCheck) {
                db.collection('rosters')
                .add({
                    season_id: roster.season_id,
                    team_id: roster.team_id,
                    selected_player_ids: roster.selected_player_ids,
                    created_at: moment().toDate(),
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/rosters')
                    commit('setSnack', 'Roster created.')
                })
                .catch((err) => {
                    console.log(`Error adding roster to database. ${err}`)
                    commit('setSnack', 'Error roster division.')
                })
            } else {
                commit(
                    'setSnack',
                    'Roster already exists for this team and season.'
                )
            }
        },

        deleteRoster({ commit }, { roster }) {
            db.collection('rosters')
            .doc(roster.id)
            .delete()
            .then(() => {
                commit('setSnack', 'Roster deleted.')
            })
            .catch((err) => {
                console.log(`Error deleting roster from database. ${err}`)
                commit('setSnack', 'Error deleting roster.')
            })
        },

        updateRoster({ commit }, roster) {
            db.collection('rosters')
            .doc(roster.id)
            .update({
                selected_player_ids: roster.selected_player_ids,
                updated_at: moment().toDate()
            })
            .then(() => {
                router.push('/admin/rosters')
                commit('setSnack', 'Roster updated.')
            })
            .catch((err) => {
                console.log(`Error updating roster in database. ${err}`)
                commit('setSnack', 'Error updating roster.')
            })
        },

        loadMatchData({state, commit}) {
            // Get matches from Firebase and load into store.
            // Matches will be updated in realtime.
            db.collection('matches')
            .where('season_id', '==', state.selectedSeason.id)
            .onSnapshot(
                (matchesCollection) => {
                    let matches = []

                    matchesCollection.forEach((match) => {
                        let matchData = match.data()
                        matchData.id = match.id
                        matchData.match_moment = moment.unix(matchData.match_datetime.seconds)
                        if (matchData.home_team_score + matchData.away_team_score >= 0) {
                            matchData.game_played = true
                        } else {
                            matchData.game_played = false
                        }
                        matches.push(matchData)
                    })

                    commit('setMatches', matches)
                },
                (error) => {
                    console.log(`Error loading matches: ${error}`)
                    commit('setSnack', 'Error loading matches.')
                }
            )
        },

        createMatch({ commit, getters }, match) {
            // Get results of match time conflict result.
            let matchCheckResults = getters.getMatchTimeConflicts({
                season_id: match.season_id,
                newMatchStartTime: moment(match.match_datetime),
                away_team_id: match.away_team_id,
                home_team_id: match.home_team_id,
                duration: match.duration
            })

            if (matchCheckResults.validMatchTime) {
                db.collection('matches')
                .add({
                    away_team_id: match.away_team_id,
                    away_team_score: match.away_team_score,
                    home_team_id: match.home_team_id,
                    home_team_score: match.home_team_score,
                    duration: match.duration,
                    match_datetime: match.match_datetime,
                    season_id: match.season_id,
                    location_id: match.location_id,
                    created_at: moment().toDate(),
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/matches')
                    commit('setSnack', 'Match created.')
                })
                .catch((err) => {
                    console.log(`Error adding match to database. ${err}`)
                    commit('setSnack', 'Error creating match.')
                })
            } else {
                commit(
                    'setSnack',
                    `${matchCheckResults.teamInConflict} already has a match at this time.`
                )
            }
        },

        deleteMatch({ commit }, match) {
            if (match.game_played) {
                commit('setSnack', 'Cannot delete completed match.')
            } else {
                db.collection('matches')
                .doc(match.id)
                .delete()
                .then(() => {
                    commit('setSnack', 'Match deleted.')
                })
                .catch((err) => {
                    console.log(`Error deleting match from database. ${err}`)
                    commit('setSnack', 'Error deleting match.')
                })
            }
        },

        updateMatch({ commit }, match) {
            db.collection('matches')
            .doc(match.id)
            .update({
                away_team_id: match.away_team_id,
                away_team_score: match.away_team_score,
                home_team_id: match.home_team_id,
                home_team_score: match.home_team_score,
                duration: match.duration,
                match_datetime: match.match_datetime,
                season_id: match.season_id,
                location_id: match.location_id,
                updated_at: moment().toDate()
            })
            .then(() => {
                router.push('/admin/matches')
                commit('setSnack', 'Match updated.')
            })
            .catch((err) => {
                console.log(`Error updating match in database. ${err}`)
                commit('setSnack', 'Error updating match.')
            })
        },

        loadPlayoffRoundsData({state, commit}) {
            // Get playoffs from Firebase and load into store.
            // Playoffs will be updated in realtime.
            db.collection('playoff_rounds')
            .where('season_id', '==', state.selectedSeason.id)
            .onSnapshot(
                (playoffRoundsCollection) => {
                    let rounds = []

                    playoffRoundsCollection.forEach((round) => {
                        let playoffRoundData = round.data()
                        playoffRoundData.id = round.id
                        rounds.push(playoffRoundData)
                    })

                    commit('setPlayoffRounds', rounds)
                },
                (error) => {
                    console.log(`Error loading playoff rounds: ${error}`)
                    commit('setSnack', 'Error loading playoff rounds.')
                }
            )
        },

        createPlayoffRound({ commit }, round) {
            db.collection('playoff_rounds')
            .add({
                round: round.round,
                round_title: round.round_title,
                best_of: round.best_of,
                season_id: round.season_id,
                created_at: moment().toDate(),
                updated_at: moment().toDate()
            })
            .then(() => {
                router.push('/admin/playoffs')
                commit('setSnack', 'Playoff round created.')
            })
            .catch((err) => {
                console.log(`Error adding playoff to database. ${err}`)
                commit('setSnack', 'Error creating playoff.')
            })
        },

        deletePlayoffRound({ commit }, round) {
            let roundIsEmpty = true

            // Makes sure there are no matchups assigned to this round.
            this.state.playoffMatchups.forEach((matchup) => {
                if (matchup.round_id === round.id) {
                    roundIsEmpty = false
                }
            })

            // Only delete the team if no matches are assigned.
            if (roundIsEmpty) {
                db.collection('playoff_rounds')
                .doc(round.id)
                .delete()
                .then(() => {
                    commit('setSnack', 'Playoff round deleted.')
                })
                .catch((err) => {
                    console.log(`Error deleting playoff round from database. ${err}`)
                    commit('setSnack', 'Error deleting playoff round.')
                })
            } else {
                commit('setSnack', 'Cannot delete round with assigned matchups.')
            }
        },

        loadPlayoffMatchupsData({state, commit}) {
            // Get playoff matchups from Firebase and load into store.
            // Playoff matchups will be updated in realtime.
            db.collection('playoff_matchups')
            .where('season_id', '==', state.selectedSeason.id)
            .onSnapshot(
                (playoffMatchupsCollection) => {
                    let matchups = []

                    playoffMatchupsCollection.forEach((matchup) => {
                        let matchupData = matchup.data()
                        matchupData.id = matchup.id
                        matchups.push(matchupData)
                    })

                    commit('setPlayoffMatchups', matchups)
                },
                (error) => {
                    console.log(`Error loading playoff matchups: ${error}`)
                    commit('setSnack', 'Error loading playoff matchups.')
                }
            )
        },

        createPlayoffMatchup({ commit }, matchup) {
            db.collection('playoff_matchups')
            .add({
                season_id: matchup.season.id,
                round_id: matchup.round.id,
                away_team_id: matchup.away_team_id,
                home_team_id: matchup.home_team_id,
                created_at: moment().toDate(),
                updated_at: moment().toDate()
            })
            .then((matchupDocument) => {
                let firestorePromises = []

                // Function to add matches to firestore.
                let createMatch = (
                    matchup,
                    matchupDocument,
                    game,
                    matchTitle,
                    awayTeamId,
                    homeTeamId
                ) => {
                    return db.collection('playoff_matches').add({
                        season_id: matchup.season.id,
                        round_id: matchup.round.id,
                        matchup_id: matchupDocument.id,
                        match: game,
                        match_title: matchTitle,
                        away_team_id: awayTeamId,
                        away_team_score: -1,
                        home_team_id: homeTeamId,
                        home_team_score: -1,
                        match_datetime: null,
                        created_at: moment().toDate(),
                        updated_at: moment().toDate()
                    })
                }

                // Create an array of createMatch functions, one for each match.
                // Number of matches created is based on round.best_of value.
                for (let i = 1; i <= matchup.round.best_of; i++) {
                    let matchTitle = `Game ${i}`

                    let awayTeamId = matchup.away_team_id
                    let homeTeamId = matchup.home_team_id

                    // Alternate home team.
                    if (i % 2 === 0) {
                        awayTeamId = matchup.home_team_id
                        homeTeamId = matchup.away_team_id
                    }

                    firestorePromises.push(
                        createMatch(
                            matchup,
                            matchupDocument,
                            i,
                            matchTitle,
                            awayTeamId,
                            homeTeamId
                        )
                    )
                }

                // Create the firestore records.
                Promise.all(firestorePromises)
                    .then(() => {
                        router.push('/admin/playoffs')
                        commit('setSnack', 'Playoff matches created.')
                    })
                    .catch((err) => {
                        console.log(`Error adding playoff matches to database. ${err}`)
                        commit('setSnack', 'Error creating playoff matches.')
                    })
            })
            .catch((err) => {
                console.log(`Error adding playoff to database. ${err}`)
                commit('setSnack', 'Error creating playoff.')
            })
        },

        deletePlayoffMatchup({ commit }, matchup) {
            let matchupHasCompletedGames = false

            // Makes sure there are no completed games for this matchup.
            this.state.playoffMatches.forEach((match) => {
                if (match.matchup_id === matchup.id && match.game_played) {
                    matchupHasCompletedGames = true
                }
            })

            if (matchupHasCompletedGames) {
                commit('setSnack', 'Cannot delete matchup with a completed match.')
            } else {
                // Delete matches assigned to matchup as well as matchup.
                db.collection('playoff_matches')
                .where('matchup_id', '==', matchup.id)
                .get()
                .then(function() {
                    db.collection('playoff_matchups')
                    .doc(matchup.id)
                    .delete()
                    .then(() => {
                        commit('setSnack', 'Playoff matchup and matches deleted.')
                    })
                    .catch((err) => {
                        console.log(`Error deleting playoff matchup from database. ${err}`)
                        commit('setSnack', 'Error deleting playoff matchup.')
                    })
                })
                .catch((err) => {
                    console.log(`Error removing playoff matches from database. ${err}`)
                    commit('setSnack', 'Error deleting playoff matches.')
                })
            }
        },

        loadPlayoffMatchesData({state, commit}) {
            // Get playoff matches from Firebase and load into store.
            // Playoff matches will be updated in realtime.
            db.collection('playoff_matches')
            .where('season_id', '==', state.selectedSeason.id)
            .onSnapshot(
                (playoffMatchesCollection) => {
                    let matches = []

                    playoffMatchesCollection.forEach((match) => {
                        let matchData = match.data()
                        matchData.id = match.id
                        matchData.match_moment = null
                        if (matchData.match_datetime) {
                            let matchMoment = moment.unix(matchData.match_datetime.seconds)
                            if (moment.isMoment(matchMoment)) {
                                matchData.match_moment = matchMoment
                            }
                        }
                        if (matchData.home_team_score + matchData.away_team_score >= 0) {
                            matchData.game_played = true
                        } else {
                            matchData.game_played = false
                        }
                        matches.push(matchData)
                    })

                    commit('setPlayoffMatches', matches)
                },
                (error) => {
                    console.log(`Error loading playoff matches: ${error}`)
                    commit('setSnack', 'Error loading playoff matches.')
                }
            )
        },

        deletePlayoffMatch({ commit }, match) {
            if (match.game_played) {
                commit('setSnack', 'Cannot delete completed playoff match.')
            } else {
                db.collection('playoff_matches')
                .doc(match.id)
                .delete()
                .then(() => {
                    commit('setSnack', 'Playoff match deleted.')
                })
                .catch((err) => {
                    console.log(`Error deleting playoff match from database. ${err}`)
                    commit('setSnack', 'Error deleting playoff match.')
                })
            }
        },

        updatePlayoffMatch({ commit, getters }, match) {
            let fullMatch = getters.getPlayoffMatchById(match.id)

            if (match.match_datetime) {
                db.collection('playoff_matches')
                .doc(match.id)
                .update({
                    away_team_score: match.away_team_score,
                    home_team_score: match.home_team_score,
                    match_datetime: match.match_datetime,
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/playoffs')
                    commit('setSnack', 'Playoff match updated.')

                    // If a team has won, remove remaining games.
                    let matchup = getters.getPlayoffMatchupById(
                        fullMatch.matchup_id
                    )
                    let teamWins = getters.getPlayoffMatchupWins(matchup)
                    if (
                        teamWins.homeTeamWins > teamWins.bestOf / 2 ||
                        teamWins.awayTeamWins > teamWins.bestOf / 2
                    ) {
                        db.collection('playoff_matches')
                        .where('matchup_id', '==', fullMatch.matchup_id)
                        .where('away_team_score', '==', -1)
                        .where('home_team_score', '==', -1)
                        .get()
                        .then(function(querySnapshot) {
                            var batch = db.batch()

                            querySnapshot.forEach(function(doc) {
                                batch.delete(doc.ref)
                            })

                            return batch.commit()
                        })
                        .catch((err) => {
                            console.log(
                                `Error removing remaining matches in database. ${err}`
                            )
                            commit(
                                'setSnack',
                                'Error removing remaining playoff matches.'
                            )
                        })
                    }
                })
                .catch((err) => {
                    console.log(`Error updating playoff match in database. ${err}`)
                    commit('setSnack', 'Error updating playoff match.')
                })
            } else {
                console.log('Error playoff match is missing time.')
                commit('setSnack', 'Error playoff match is missing time.')
            }
        },

        loadPlayersData(context) {
            db.collection('players').onSnapshot(
                (playersCollection) => {
                    let players = []

                    playersCollection.forEach((player) => {
                        let playerData = player.data()
                        playerData.id = player.id
                        players.push(playerData)
                    })

                    context.commit('setPlayers', players)
                },
                (error) => {
                    console.log(`Error loading players: ${error}`)
                    this.commit('setSnack', 'Error loading players.')
                }
            )
        },

        createPlayer({ commit, getters }, player) {
            let playerDuplicateCheck = getters.getPlayerIsDuplicate({
                first_name: player.first_name,
                last_name: player.last_name
            })

            if (!playerDuplicateCheck) {
                db.collection('players')
                .add({
                    first_name: player.first_name,
                    last_name: player.last_name,
                    email: player.email,
                    phone: player.phone,
                    created_at: moment().toDate(),
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/players')
                    commit('setSnack', 'Player created.')
                })
                .catch((err) => {
                    console.log(`Error adding player to database. ${err}`)
                    commit('setSnack', 'Error creating player.')
                })
            } else {
                commit(
                    'setSnack',
                    'Player already exists.'
                )
            }
        },

        deletePlayer({ commit, getters }, { player }) {
            let playerStats = getters.getPlayerByPlayerId(player.id)

            if (playerStats.length === 0)
            {
                db.collection('players')
                .doc(player.id)
                .delete()
                .then(() => {
                    commit('setSnack', 'Player deleted.')
                })
                .catch((err) => {
                    console.log(`Error deleting player from database. ${err}`)
                    commit('setSnack', 'Error deleting player.')
                })
            } else {
                commit(
                    'setSnack',
                    'Cannot remove player with statistics.'
                )
            }
        },

        updatePlayer({ commit, getters }, player) {
            let playerDuplicateCheck = getters.getPlayerIsDuplicate({
                first_name: player.first_name,
                last_name: player.last_name
            })

            if (!playerDuplicateCheck) {
                db.collection('players')
                .doc(player.id)
                .update({
                    first_name: player.first_name,
                    last_name: player.last_name,
                    email: player.email,
                    phone: player.phone,
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/players')
                    commit('setSnack', 'Player updated.')
                })
                .catch((err) => {
                    console.log(`Error updating player in database. ${err}`)
                    commit('setSnack', 'Error updating player.')
                })
            } else {
                commit(
                    'setSnack',
                    'Player already exists.'
                )
            }
        },

        loadPlayersStatsData({state, commit}) {
            db.collection('players_stats')
            .where('season_id', '==', state.selectedSeason.id)
            .onSnapshot(
                (playersStatsCollection) => {
                    let players_stats = []

                    playersStatsCollection.forEach((player_stats) => {
                        let playerStatsData = player_stats.data()
                        playerStatsData.id = player_stats.id
                        players_stats.push(playerStatsData)
                    })

                    commit('setPlayersStats', players_stats)
                },
                (error) => {
                    console.log(`Error loading players stats: ${error}`)
                    commit('setSnack', 'Error loading players stats.')
                }
            )
        },

        createPlayerStats({ commit, getters }, player_stats) {
            let playerStatsDuplicateCheck = getters.getPlayerStatsIsDuplicate({player_stats })
            let playerStatsValid = getters.getPlayerStatsValid(player_stats)

            if (playerStatsValid) {
                if (!playerStatsDuplicateCheck) {
                    db.collection('players_stats')
                    .add({
                        season_id: player_stats.season_id,
                        player_id: player_stats.player_id,
                        team_id: player_stats.team_id,
                        hr: player_stats.hr,
                        ip: player_stats.ip,
                        so: player_stats.so,
                        is_playoff_stat: player_stats.is_playoff_stat,
                        created_at: moment().toDate(),
                        updated_at: moment().toDate()
                    })
                    .then(() => {
                        router.push('/admin/players_stats')
                        commit('setSnack', 'Player stats created.')
                    })
                    .catch((err) => {
                        console.log(`Error adding player stats to database. ${err}`)
                        commit('setSnack', 'Error creating player stats.')
                    })
                } else {
                    commit(
                        'setSnack',
                        'Player stats already exist.'
                    )
                }
            } else {
                commit(
                    'setSnack',
                    'Player must have a non-zero stat.'
                )
            }
        },

        deletePlayerStats({ commit }, { player_stats }) {
            db.collection('players_stats')
            .doc(player_stats.id)
            .delete()
            .then(() => {
                commit('setSnack', 'Player stats deleted.')
            })
            .catch((err) => {
                console.log(`Error deleting player stats from database. ${err}`)
                commit('setSnack', 'Error deleting player stats.')
            })
        },

        updatePlayerStats({ commit, getters }, player_stats) {
            let playerStatsValid = getters.getPlayerStatsValid(player_stats)

            if (playerStatsValid) {
                db.collection('players_stats')
                .doc(player_stats.id)
                .update({
                    hr: player_stats.hr,
                    ip: player_stats.ip,
                    so: player_stats.so,
                    is_playoff_stat: player_stats.is_playoff_stat,
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/players_stats')
                    commit('setSnack', 'Player stats updated.')
                })
                .catch((err) => {
                    console.log(`Error updating player stats in database. ${err}`)
                    commit('setSnack', 'Error updating player stats.')
                })
            } else {
                commit(
                    'setSnack',
                    'Player must have a non-zero stat.'
                )
            }
        },

        loadPlayersPositionsData({state, commit}) {
            db.collection('players_positions')
            .where('season_id', '==', state.selectedSeason.id)
            .onSnapshot((playersPositionsCollection) => {
                let player_positions = []

                playersPositionsCollection.forEach((players_position) => {
                    let playersPositionData = players_position.data()
                    playersPositionData.id = players_position.id
                    player_positions.push(playersPositionData)
                })

                commit('setPlayersPositions', player_positions)
            },
            (error) => {
                console.log(`Error loading player positions: ${error}`)
                this.commit('setSnack', 'Error loading player positions.')
            })
        },

        createPlayerPosition({ commit, getters }, player_position) {
            let playerPositionDuplicateCheck = getters.getPlayerPositionIsDuplicate({
                player_position
            })

            if (!playerPositionDuplicateCheck) {
                db.collection('players_positions')
                .add({
                    season_id: player_position.season_id,
                    player_id: player_position.player_id,
                    position: player_position.position,
                    number: player_position.number,
                    manager: player_position.manager,
                    spare: player_position.spare,
                    created_at: moment().toDate(),
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/players_positions')
                    commit('setSnack', 'Player position created.')
                })
                .catch((err) => {
                    console.log(`Error adding player position to database. ${err}`)
                    commit('setSnack', 'Error creating player position.')
                })
            } else {
                commit(
                    'setSnack',
                    'Player position already exist.'
                )
            }
        },

        deletePlayerPosition({ commit }, { player_position }) {
            db.collection('players_positions')
            .doc(player_position.id)
            .delete()
            .then(() => {
                commit('setSnack', 'Player position deleted.')
            })
            .catch((err) => {
                console.log(`Error deleting player position from database. ${err}`)
                commit('setSnack', 'Error deleting player position.')
            })
        },

        updatePlayerPosition({ commit }, player_position) {
            db.collection('players_positions')
            .doc(player_position.id)
            .update({
                position: player_position.position,
                number: player_position.number,
                manager: player_position.manager,
                spare: player_position.spare,
                updated_at: moment().toDate()
            })
            .then(() => {
                router.push('/admin/players_positions')
                commit('setSnack', 'Player position updated.')
            })
            .catch((err) => {
                console.log(`Error updating player position in database. ${err}`)
                commit('setSnack', 'Error updating player position.')
            })
        },

        loadLocationsData(context) {
            db.collection('locations').onSnapshot(
                (locationsCollection) => {
                    let locations = []

                    locationsCollection.forEach((location) => {
                        let locationData = location.data()
                        locationData.id = location.id
                        locations.push(locationData)
                    })

                    context.commit('setLocations', locations)
                },
                (error) => {
                    console.log(`Error loading locations: ${error}`)
                    this.commit('setSnack', 'Error loading locations.')
                }
            )
        },

        createLocation({ commit, getters }, location) {
            let locationDuplicateCheck = getters.getLocationIsDuplicate({
                location: location.location
            })

            if (!locationDuplicateCheck) {
                db.collection('locations')
                .add({
                    location: location.location,
                    created_at: moment().toDate(),
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/locations')
                    commit('setSnack', 'Location created.')
                })
                .catch((err) => {
                    console.log(`Error adding location to database. ${err}`)
                    commit('setSnack', 'Error creating location.')
                })
            } else {
                commit(
                    'setSnack',
                    'Location already exists.'
                )
            }
        },

        deleteLocation({ commit }, { location }) {
            let locationIsUsed = false

            // Make sure the location is not used.
            this.state.matches.forEach((match) => {
                if (match.location_id === location.id) {
                    locationIsUsed = true
                }
            })

            if (!locationIsUsed) {
                db.collection('locations')
                .doc(location.id)
                .delete()
                .then(() => {
                    commit('setSnack', 'Location deleted.')
                })
                .catch((err) => {
                    console.log(`Error deleting location from database. ${err}`)
                    commit('setSnack', 'Error deleting location.')
                })
            } else {
                commit('setSnack', 'Cannot delete a location being used.')
            }
        },

        updateLocation({ commit, getters }, location) {
            let locationDuplicateCheck = getters.getLocationIsDuplicate({
                location: location.location
            })

            if (!locationDuplicateCheck) {
                db.collection('locations')
                .doc(location.id)
                .update({
                    location: location.location,
                    updated_at: moment().toDate()
                })
                .then(() => {
                    router.push('/admin/locations')
                    commit('setSnack', 'Location updated.')
                })
                .catch((err) => {
                    console.log(`Error updating location in database. ${err}`)
                    commit('setSnack', 'Error updating location.')
                })
            } else {
                commit(
                    'setSnack',
                    'Location already exists.'
                )
            }
        }
    }
})
